export default __webpack_public_path__ + "static/media/screen4.f31a9515.png";